// extracted by mini-css-extract-plugin
export default {"Label":"FieldLabel_Label__MaNSy","NoMb":"FieldLabel_NoMb__CZ7XG","DarkLabel":"FieldLabel_DarkLabel__4MESd"};